import { wsConstants, initialWsState } from '../_constants';

// The generator presigns its links for 600 s just before it sends them. Trust
// one for 540 s after it arrives, so a slow download still finishes inside the
// signature rather than failing part way.
export const CREATED_LINK_TTL_MS = 540 * 1000;

// The GLB link the generator sent for scan `id`, while it is still good;
// otherwise null, and the caller presigns through the API as for any scan.
// Only the GLB: the generator signs the USDZ link while the USDZ is still
// being made, so that link can point at nothing yet.
export function createdLink(ws, id, now = Date.now()) {
  const created = ws && ws.created;
  if (!created || !id || created.id !== id) return null;
  if (now - created.receivedAt > CREATED_LINK_TTL_MS) return null;
  return created.glb;
}

function createdFrom(action) {
  const glb = action.msg && action.msg.glb;
  if (!action.id || typeof glb !== 'string' || !glb.startsWith('https://')) return null;
  return { id: action.id, glb, receivedAt: action.receivedAt };
}

export function ws(state = initialWsState, action) {
  switch(action.type) {
    case wsConstants.CONNECT:
      console.log("Connecting...")
      return { ...state, host: action.host, id: action.id, connecting: action.connectTimeout };
    case wsConstants.CONNECTED:
      console.log('Connected.');
      clearTimeout(state.connecting);
      return { ...state, connecting: null, connected: true };
    case wsConstants.PENDING:
      console.log('Upload(s) complete.')
      return { ...state, pending: action.id };
    case wsConstants.SEND:
      console.log("Creating Origami...")
      return { ...state, pending: null, making: action.makerTimeout };
    case wsConstants.RECEIVE:
      console.log("Origami created.");
      clearTimeout(state.making);
      return { ...state, making: null, created: createdFrom(action) };
    case wsConstants.DISCONNECT:
      console.log("Disconnecting...");
      return state;
    case wsConstants.DISCONNECTED:
      console.log("Connection closed.");
      // The generator closes the socket straight after sending the links, so
      // they must outlive it.
      return { ...initialWsState, created: state.created };
    default:
      return state;
  }
}
